import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalCommand.CatalogItemDetails'

export default defineMessages({
  collapseAriaLabel: {
    id: `${scope}.collapseAriaLabel`,
    defaultMessage: 'Collapse details panel',
  },
  sku: {
    id: `${scope}.sku`,
    defaultMessage: 'SKU: {sku}',
  },
  agentAnalysisTitle: {
    id: `${scope}.agentAnalysisTitle`,
    defaultMessage: 'Agent analysis',
  },
  catalogDetailsTitle: {
    id: `${scope}.catalogDetailsTitle`,
    defaultMessage: 'Catalog details',
  },
  thumbnailAriaLabel: {
    id: `${scope}.thumbnailAriaLabel`,
    defaultMessage: 'Show product image {position} of {total}',
  },
  listPriceLabel: {
    id: `${scope}.listPriceLabel`,
    defaultMessage: 'List:',
  },
  savingsHint: {
    id: `${scope}.savingsHint`,
    defaultMessage: 'Save {pct}% on {label}',
  },
  volumePricingTitle: {
    id: `${scope}.volumePricingTitle`,
    defaultMessage: 'Volume pricing',
  },
  perUnitSuffix: {
    id: `${scope}.perUnitSuffix`,
    defaultMessage: '/unit',
  },
})
